import { APP_BOOTSTRAP_LISTENER, ModuleWithProviders, NgModule, NgZone } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import 'signalr/jquery.signalR';

import { PushHubToken } from './PushHubToken';
import { PushServiceConfigToken } from './PushService';
import { SignalRHubsConnection } from './SignalRHubsConnection';
import { SignalRHubsConnectionToken } from './SignalRHubsConnectionToken';
import { SignalRStartupToken } from './SignalRStartupToken';
import { SignalrConnectionStatusComponent } from './SignalRConnectionStatus.Component';

const hubsConnection: SignalRHubsConnection = new SignalRHubsConnection(
	'/push',
	{
		clientMethods: [
			'routeMessage',
			'routeBatchMessages'
		],
		serverMethods: [
			'dispatch',
			'dispatchOnDisconnect',
			'publish',
			'setToken',
			'subscribe',
			'tryCancelDisconnectCommand',
			'unsubscribe'
		]
	}
);

const components = [
	SignalrConnectionStatusComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		TranslateModule
	],
	providers: [
		{
			provide: APP_BOOTSTRAP_LISTENER,
			deps: [NgZone],
			useFactory: onAppBootstrap,
			multi: true
		},
		{ provide: PushHubToken, useValue: hubsConnection.getProxy() },
		{ provide: SignalRHubsConnectionToken, useValue: hubsConnection },
		{ provide: SignalRStartupToken, useValue: hubsConnection.startupPromise }
	]
})
export class PushModule {
	public static forRoot(httpCommandDispatchEnabled: boolean = false): ModuleWithProviders<PushModule> {
		return {
			ngModule: PushModule,
			providers: [
				{ provide: PushServiceConfigToken, useValue: { httpCommandDispatchEnabled } }
			]
		};
	}
}

function onAppBootstrap(zone: NgZone) {
	return () => hubsConnection.zone = zone;
}
